import { useMemo } from 'react';

import { Recruitment, WithUsers } from 'entities';

import { RecruitmentModal } from 'pages/Recruitment/components';
import { useMultiState } from 'hooks';
import { quickContext } from 'utils/react';

export type OnRecruitment = (recruitment: WithUsers<Recruitment, 'owner'>) => void;

type State = {
  focusedRecruitment?: string | null;
  onRecruitment?: OnRecruitment;
};

const { useRecruitmentAssign, withRecruitmentAssignContext } = quickContext(
  'recruitmentAssign',
  () => {
    const { values, dispatch, resetDefault } = useMultiState<State>({
      focusedRecruitment: null,
    });

    const data = useMemo(
      () => ({
        openRecruitment: (id: string, onRecruitment: OnRecruitment) =>
          dispatch({ focusedRecruitment: id, onRecruitment: () => onRecruitment }),

        closeRecruitment: resetDefault,
      }),
      [dispatch, resetDefault],
    );

    return {
      data,

      content: (
        <RecruitmentModal
          recruitmentId={values.focusedRecruitment}
          close={data.closeRecruitment}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onData={values.onRecruitment as any}
        />
      ),
    };
  },
);

export { useRecruitmentAssign, withRecruitmentAssignContext };
